import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import MetalType from '../EngagementLandingPage/MetalType'
import FineBannar from './FineBannar'
import FineCollection from './FineCollection'

const FineJeweleryStaticPage = () => {
    const metaDetails = useSelector(state => state.persistedReducer.meta.meta)
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails?.title}</title>
                <meta name="description" content={metaDetails?.description}></meta>
                <meta name="keywords" content={metaDetails?.keywords}></meta>
            </Helmet>
            <div className='dfl_fine_jewelery_section'>
                <FineBannar />
                <FineCollection />
                <MetalType />
            </div>
        </>

    )
}

export default FineJeweleryStaticPage